export default "__VITE_ASSET__DC6vU_PP__"